import React from 'react';
import InnerSelect from 'react-select';
import {withStyles} from '@material-ui/core/styles';
import components from './components';
import styles from './styles';
import i18n from "../../../i18n";

const BaseSelect = ({classes, theme, fullWidth, label, name, multiple, error, touched, ...props}) => {
    const selectStyles = {
        input: base => ({
            ...base,
            color: theme.palette.text.primary,
            '& input': {
                font: 'inherit',
            },
        }),
    };

    return (
        <InnerSelect
            id={name}
            name={name}
            classes={classes}
            styles={selectStyles}
            components={components}
            noOptionsMessage={() => i18n.get('default.select.noOptions')}
            textFieldProps={{
                label,
                fullWidth,
                error: touched && !!error,
                helperText: touched && error,
                InputLabelProps: {
                    shrink: true,
                },
            }}
            isMulti={multiple}
            placeholder={label}
            {...props}
        />
    );
};

BaseSelect.defaultProps = {
    fullWidth: true,
};


export default withStyles(styles, {withTheme: true})(BaseSelect);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Form/Select/BaseSelect.jsx